import { addListener, debounce, isEmpty } from './helpers';
import TweenMax from 'gsap/TweenMax';
import { _gsScope } from 'gsap/all';
import * as PIXI from 'pixi.js-legacy';
_gsScope.PIXI = PIXI;

// ***************************************
// Animation manager

const pixiAnimations = [];

function setup(elem, settings, defaultTweenOptions = {
    ease: Sine.easeInOut,
    force3D: true,
    repeat: -1,
    yoyoEase: true
}) {
    const id = elem.dataset.animationId;
    const app = pixiAnimations[id] = new PIXI.Application({
        antialias: true,
        autoDensity: true,
        autoSize: true,
        forceCanvas: true,
        resizeTo: elem,
        transparent: true
    });
    elem.appendChild(app.view);

    // Sprite container.
    const container = new PIXI.Container();
    app.stage.addChild(container);

    // Create a sprite from each asset.
    const { sprites, options } = settings;
    sprites.map(({ src, offsetX, offsetY, duration, tweenOptions }) => {
        const sprite = new PIXI.Sprite.from(src);
        sprite.anchor.set(0.5);
        sprite.x = sprite.x + (offsetX || 0);
        sprite.y = sprite.y + (offsetY || 0);
        container.addChild(sprite);

        // Sprite animation.
        if (! isEmpty(tweenOptions)) {
            app.tweening = TweenMax.to(sprite, duration || 0, {
                ...defaultTweenOptions,
                ...tweenOptions
            });
        }
    });

    // Center the container after we've added the sprites.
    container.x = app.screen.width / 2;
    container.y = app.screen.height / 2;

    // Add resize handler to window, to handle resizing of the app.stage.
    addListener('resize', [window], debounce(() => {
        stageResize(app, container);
    }, 1000));

    // Run this on initlal load to set any screen related state.
    stageResize(app, container);
}

// Handle stage resize events. NB this function seems a little lite
// at the moment, but it should still be broken out incase this gets
// more complex.
function stageResize({ screen }, container) {
    container.x = screen.width / 2;
    container.y = screen.height / 2;

    if (screen.width >= 440 && screen.width < 590) {
        container.scale.x = container.scale.y = 0.6;
    }

    if (screen.width < 440) {
        container.scale.x = container.scale.y = 0.54;
    }
}

export function init(containers, options) {
    try {
        [...containers]
            .filter(({ dataset }) => typeof options[dataset.animationId] !== 'undefined')
            .map((elem) => setup(elem, options[elem.dataset.animationId]));
    } catch (error) {
        console.log(error);
        return;
    }
}
